import React from "react";

const USDAmount = ({ row }) => {
  return <div>{row?.usdAmount?.toLocaleString()}</div>;
};

export default USDAmount;
